import { IQuestionModel } from '@care-portals/api-interfaces';

// US Specific Questions
const questionsModels: IQuestionModel[] = [
  {
    field: 'edinterest',
    label: 'Why are you interested in erectile dysfunction medication?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'edinterestStronger',
          value: 'Stronger or Longer Erections'
        },
        {
          key: 'edinterestImprove',
          value: 'Improve Intimacy With Partner'
        },
        {
          key: 'edinterestRelief',
          value: 'Relief From Enlarged Prostate Symptoms'
        },
        {
          key: 'edinterestOther',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'edinterestOtherDesc',
            placeholder: 'Please describe'
          }
        }
      ],
      fullWidth: true
    }
  },
  {
    field: 'edTakenMed',
    label:
      'Have you taken any of the following as treatment for Erectile Dysfunction?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'edTakenMedSildenafil',
          value: 'Sildenafil (Viagra)'
        },
        {
          key: 'edTakenMedTadaladil',
          value: 'Tadalafil (Cialis)'
        },
        {
          key: 'edTakenMedVardenafil',
          value: 'Vardenafil (Levitra)'
        },
        {
          key: 'edTakenMedAvanafil',
          value: 'Avanafil (Stendra)'
        },
        {
          key: 'edTakenMedTrt',
          value: 'Testosterone support/replacement'
        },
        {
          key: 'edTakenMedPenileInjection',
          value: 'Penile injections'
        },
        {
          key: 'edTakenMedPenileSurgery',
          value: 'Penile surgery or use of pumps'
        },
        {
          key: 'edTakenMedNone',
          value: 'None of the above',
          uncheckOthers: true
        }
      ],
      fullWidth: true
    }
  },
  {
    field: 'currSexDur',
    label:
      'How would you describe your current sexual performance? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'difficulty_forming_an_erection',
          value: 'Difficulty forming an erection'
        },
        {
          key: 'difficulty_maintaining_an_erection',
          value: 'Difficulty maintaining an erection'
        },
        {
          key: 'ejaculating_too_early',
          value: 'Ejaculating too early (premature ejaculation)'
        },
        {
          key: 'low_libido',
          value: 'Low libido'
        },
        {
          key: 'not_sexually_active',
          value: 'Not sexually active'
        },
        {
          key: 'no_performance_issues',
          value: 'No performance issues'
        },
        {
          key: 'edinterestOther',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'currSexDurOtherDesc',
            placeholder: 'Please describe'
          }
        }
      ],
      fullWidth: true
    }
  },
  {
    field: 'everUsedNit',
    label:
      'Have you ever been prescribed or used nitrates? Examples of common nitrates include: Nitroglycerin (Nitro-Dur, Nitrolingual or Nitrostat), Isosorbide (Dilatrate or Isordil), Nitroprusside (Nitropress) or Amyl nitrite ("poppers”).',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'everUsedNitYes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'everUsedNitYesDesc',
            placeholder: 'Please explain'
          }
        },
        { key: 'everUsedNitNo', value: 'No' }
      ]
    }
  },
  {
    field: 'lastMornErect',
    label: 'When was the last time you had a morning erection?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'less_than_3_months_ago',
          value: 'Less than 3 months ago'
        },
        {
          key: 'between_3_and_6_months_ago',
          value: 'Between 3 and 6 months ago'
        },
        { key: 'over_6_months_ago', value: 'Over 6 months ago' },
        {
          key: 'i_have_never_had_a_morning_erection',
          value: 'I have never had a morning erection'
        }
      ]
    }
  },
  {
    field: 'lastNormSexFunc',
    label:
      'When was the last time you had what you consider "normal" sexual function?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'less_than_3_months_ago',
          value: 'Less than 3 months ago'
        },
        {
          key: 'between_3_and_6_months_ago',
          value: 'Between 3 and 6 months ago'
        },
        { key: 'over_6_months_ago', value: 'Over 6 months ago' },
        { key: 'never', value: 'Never' }
      ]
    }
  },
  {
    field: 'apprxDateRecBP',
    label:
      'What was the approximate date of your most recent blood pressure reading?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'apprxDateRecBPDesc',
      placeholder: ''
    }
  },
  {
    field: 'everBPTooHighLow',
    label:
      'Have you ever been told your blood pressure is too high or too low?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'everBPTooHighLowYes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'everBPTooHighLowYesDesc',
            placeholder: 'Please explain'
          }
        },
        { key: 'everBPTooHighLowNo', value: 'No' }
      ]
    }
  },
  {
    field: 'recentSysBP',
    label:
      'What was your most recent Systolic (top number) blood pressure reading?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'systolic_bp_80_100',
          value: 'Systolic BP 80-100'
        },
        { key: 'systolic_bp_101_159', value: 'Systolic BP 101-159' },
        { key: 'systolic_bp_160_200', value: 'Systolic BP 160-200+' },
        { key: 'unknown', value: 'Unknown' }
      ]
    }
  },
  {
    field: 'recentDiaBP',
    label:
      'What was your most recent Diastolic (bottom number) blood pressure reading?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'diastolic_bp_50_60',
          value: 'Diastolic BP 50-60'
        },
        { key: 'diastolic_bp_61_90', value: 'Diastolic BP 61-90' },
        { key: 'diastolic_bp_90_110', value: 'Diastolic BP 90-110+' },
        { key: 'unknown', value: 'Unknown' }
      ]
    }
  },
  {
    field: 'everExperiencedAnyOfTheFollowing',
    label:
      'Have you ever experienced any of the following? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'heart_problems_such_as_angina_heart_failure_irregular_heartbeats_or_have_had_a_heart_attack',
          value:
            'Heart problems such as angina, heart failure, irregular heartbeats, or have had a heart attack.'
        },
        {
          key: 'heart_or_artery_malformation',
          value: 'Heart or artery malformation'
        },
        {
          key: 'have_had_a_stroke',
          value: 'Have had a stroke'
        },
        {
          key: 'have_retinitis_pigmentosa_a_rare_genetic_eye_disease',
          value: 'Have retinitis pigmentosa, a rare genetic eye disease'
        },
        {
          key: 'have_ever_had_severe_vision_loss_including_a_condition_called_naion',
          value:
            'Have ever had severe vision loss, including a condition called NAION'
        },
        {
          key: 'have_stomach_ulcers',
          value: 'Have stomach ulcers'
        },
        {
          key: 'have_a_bleeding_problem',
          value: 'Have a bleeding problem'
        },
        {
          key: 'have_a_bent_deformed_penis_shape_or_peyronie_s_disease',
          value: 'Have a bent/deformed penis shape or Peyronie’s disease'
        },
        {
          key: 'have_had_an_erection_that_lasted_more_than_4_hours',
          value: 'Have had an erection that lasted more than 4 hours'
        },
        {
          key: 'have_blood_cell_problems_such_as_sickle_cell_anemia_multiple_myeloma_or_leukemia',
          value:
            'Have blood cell problems such as sickle cell anemia, multiple myeloma, or leukemia'
        },
        {
          key: 'trauma_to_the_pelvic_area',
          value: 'Trauma to the pelvic area'
        },
        {
          key: 'none_of_the_above',
          value: 'None of the above'
        }
      ],
      fullWidth: true
    }
  },
  {
    field: 'feelHealthyForSex',
    label: 'Do you feel healthy enough to have sex?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes_i_feel_healthy_enough_for_sex_and_have_no_health_problems',
          value:
            'Yes, I feel healthy enough for sex and have no health problems'
        },
        {
          key: 'yes_i_feel_healthy_enough_for_sex_even_though_i_have_some_health_problems',
          value:
            'Yes, I feel healthy enough for sex even though I have some health problems'
        },
        {
          key: 'no_i_do_not_feel_healthy_enough_for_sex_due_to_health_problems',
          value:
            'No, I do not feel healthy enough for sex due to health problems'
        }
      ]
    }
  },
  {
    field: 'causeSexualIssues',
    label:
      'What do you think causes the issues with your sexual function? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'aging_getting_older',
          value: 'Aging/getting older'
        },
        {
          key: 'stress',
          value: 'Stress'
        },
        {
          key: 'surgery',
          value: 'Surgery'
        },
        {
          key: 'medications',
          value: 'Medications'
        },
        {
          key: 'aging_getting_older',
          value: 'Aging/getting older'
        },
        {
          key: 'causeSexualIssuesOther',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'causeSexualIssuesOtherDesc',
            placeholder: 'Please explain'
          }
        }
      ],
      fullWidth: true
    }
  },
  {
    field: 'last3MonthsRecreationalDrugs',
    label:
      'In the last three months have you used any of the following recreational drugs? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'cocaine',
          value: 'Cocaine'
        },
        {
          key: 'poppers',
          value: 'Poppers'
        },
        {
          key: 'amphetamines',
          value: 'Amphetamines'
        },
        {
          key: 'opioids_heroin',
          value: 'Opioids/Heroin'
        },
        {
          key: 'no',
          value:
            'No - I have not used any recreational drugs in the past three months'
        },
        {
          key: 'last3MonthsRecreationalDrugsOther',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'last3MonthsRecreationalDrugsDesc',
            placeholder: 'Please explain'
          }
        }
      ],
      fullWidth: true
    }
  },
  {
    field: 'anythingElseToKnow',
    label:
      'Is there anything else you want your prescriber to know about your condition or health?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'anythingElseToKnowYes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'anythingElseToKnowYesDesc',
            placeholder: 'Please explain'
          }
        },
        {
          key: 'anythingElseToKnowNo',
          value: 'No'
        }
      ]
    }
  }
];

export default questionsModels;
